export const LoadingDotsAnimations = Object.freeze({
    Pulse: 'pulse',
    Bounce: 'bounce'
});

export type LoadingDotsAnimation = (typeof LoadingDotsAnimations)[keyof typeof LoadingDotsAnimations];
